import { PlainButton } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { ReactComponent as ChevronRightIcon } from "./assets/chevron-right.svg";

export interface FieldBoxProps {
  title: ReactNode;
  subtitle: ReactNode;
  customEndSlot?: ReactNode;
  className?: string;
}

export const FieldBox: FC<FieldBoxProps> = ({
  title,
  subtitle,
  customEndSlot,
  className,
}) => (
  <div
    className={cx(
      "flex items-center justify-between rounded-xl bg-grey-100 px-8 py-6",
      className
    )}
  >
    <div className="flex flex-col gap-1.5">
      <span className="text-base font-medium text-dark">{title}</span>
      <div className="flex items-center gap-1.5 text-xs text-[#828282]">
        {subtitle}
      </div>
    </div>
    {customEndSlot || (
      <PlainButton className="flex h-8 w-8 items-center justify-center rounded-full transition-colors hover:bg-grey-200">
        <ChevronRightIcon />
      </PlainButton>
    )}
  </div>
);
